import { PageRoutes } from '@/constants/PageRoutes'
import {
  UCenterServices,
  ContractServices,
  UniServices,
  AppServices,
  CloudComputingPowerServices,
  SotcServices,
  type ResponseInterceptor,
  LoginExpiredStatusList,
  KycServices,
  SumSubServices,
} from 'network'
import { useUserInfoStore } from 'store'

/** 需要重定向的登录页的页面集合 */
const REDIRECT_LOGIN_PAGE_LIST = [PageRoutes.UserCenter]

const isRedirectLoginPage = (path: string) => {
  return REDIRECT_LOGIN_PAGE_LIST.some((page) => path.includes(page))
}

export const servicesInterceptor = () => {
  const router = useRouter()
  const userInfoStore = useUserInfoStore()
  const interceptor: ResponseInterceptor = (url, options, result) => {
    if (LoginExpiredStatusList.includes(result.status) && isRedirectLoginPage(window.location.pathname)) {
      userInfoStore.logout()
      router.replace(PageRoutes.Login)
    }
  }

  UCenterServices.responseInterceptor(interceptor)
  ContractServices.responseInterceptor(interceptor)
  UniServices.responseInterceptor(interceptor)
  AppServices.responseInterceptor(interceptor)
  CloudComputingPowerServices.responseInterceptor(interceptor)
  SotcServices.responseInterceptor(interceptor)
  KycServices.responseInterceptor(interceptor)
  SumSubServices.responseInterceptor(interceptor)
}
